var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.72 15.38-3.21-3.2a7.478 7.478 0 0 0 1.596-4.627 7.553 7.553 0 1 0-7.553 7.553 7.478 7.478 0 0 0 4.626-1.595l3.201 3.21a.944.944 0 0 0 1.34 0 .944.944 0 0 0 0-1.341ZM1.889 7.553a5.665 5.665 0 1 1 11.33 0 5.665 5.665 0 0 1-11.33 0Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgSearch;